<template>
    <div class="bodyshop-message">
        <div class="form-group">
            <label class="form-label" for="message">Nachricht an die Werkstatt senden:</label>
            <textarea name="message" v-model="formdata.message" class="form-control" maxlength="512" placeholder="Ihre Nachricht" id="message"></textarea>
            <p class="small text-muted m-0 mr-2 text-right"><span class="message-counter">{{ formdata.message.length }} / 512 Zeichen</span></p>
        </div>
        <button class="btn btn-primary my-1 mr-1" @click="onSendMessageToBodyshop()" :class="{ disabled: !formdata.message || loading }" v-if="!sent">
            <div class="spinner-border text-white mr-2" role="status" v-if="loading">
                <span class="sr-only">Loading...</span>
            </div>
            Nachricht an die Werkstatt senden
        </button>
        <span class="badge badge-pill badge-success" v-if="sent">Vielen Dank für Ihre Nachricht!</span>
        <span class="badge badge-pill badge-danger" v-if="error">Es ist ein Fehler beim Senden der Nachricht aufgetreten.</span>
    </div>
</template>

<script>
export default {
    name: "KSRMessageToBodyshop",
    data() {
        return {
            formdata: {
                jobId: '',
                storeId: '',
                message: '',
            },
            loading: false,
            sent: false,
            error: false
        }
    },
    mounted() {
        this.formdata.jobId = this.jobId;
        this.formdata.storeId = this.storeId;
    },
    computed: {
    },
    methods: {
        onSendMessageToBodyshop() {
            var data = {
                formdata: this.formdata
            }
            this.loading = true;
            var _this = this;
            axios.post('/api/ksr/send-message?identityToken='+this.kit, data)
            .then((response) => {
                if(response.data.status == 'success') {
                    _this.sent = true;
                    _this.formdata.message = '';
                }
                else {
                    _this.error = true;
                }
                _this.loading = false;
            });
        }
    },
    props: ['kit', 'storeId', 'jobId']
};
</script>
